// ------------------------------------------------------------------
// PURE BLISS CLEAN — EDITABLE SITE CONTENT
// Business owner: update details here. No code changes needed.
// ------------------------------------------------------------------

export const BUSINESS = {
  name: "Pure Bliss Clean",
  tagline: "Reliable cleaning. Genuine results. Local service.",
  phone: "0468 434 936",
  phoneHref: "tel:+61468434936",
  email: "pureblissclean@hotmail.com",
  facebook: "https://www.facebook.com/profile.php?id=61569206263770",
  facebookShare: "https://www.facebook.com/share/1DFbjNWqEq/?mibextid=wwXIfr",
  region: "Melbourne's South East",
  baseSuburb: "Carrum Downs",
};

export const SUBURBS = [
  "Carrum Downs", "Cranbourne", "Skye", "Langwarrin", "Botanic Ridge",
  "Frankston", "Berwick", "Dandenong", "Seaford", "Patterson Lakes",
  "Sandhurst", "Lyndhurst", "Carrum", "Bonbeach", "Bangholme",
  "Junction Village", "Mornington",
];

export const SERVICES = [
  { name: "Regular House Cleaning", to: "/residential-cleaning" },
  { name: "Property Management", to: "/property-managers" },
  { name: "End of Lease", to: "/end-of-lease-cleaning" },
  { name: "Deep Cleaning", to: "/residential-cleaning" },
  { name: "Commercial Cleaning", to: "/commercial-cleaning" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/residential-cleaning", label: "Residential" },
  { to: "/property-managers", label: "Property Managers" },
  { to: "/end-of-lease-cleaning", label: "End of Lease" },
  { to: "/commercial-cleaning", label: "Commercial" },
  { to: "/our-work", label: "Our Work" },
  { to: "/service-areas", label: "Areas" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const WORK_ITEMS = [
  {
    id: "cooktop",
    title: "Cooktop Restoration",
    category: "Kitchens",
    before: "/assets/work/cooktop-before.webp",
    after: "/assets/work/cooktop-after.webp",
    altBefore: "Gas cooktop with built-up grime and food residue before a Pure Bliss Clean",
    altAfter: "Spotless stainless steel gas cooktop after a detailed Pure Bliss Clean",
  },
  {
    id: "bath",
    title: "Bath Deep Clean",
    category: "Bathrooms",
    before: "/assets/work/bath-before.webp",
    after: "/assets/work/bath-after.webp",
    altBefore: "Bathtub with marks and build-up before a Pure Bliss Clean",
    altAfter: "Gleaming white bathtub after a detailed Pure Bliss Clean",
  },
  {
    id: "vanity",
    title: "Double Vanity Refresh",
    category: "Bathrooms",
    before: "/assets/work/vanity-before.webp",
    after: "/assets/work/vanity-after.webp",
    altBefore: "Bathroom double vanity before a Pure Bliss Clean",
    altAfter: "Polished bathroom double vanity and basins after a Pure Bliss Clean",
  },
  {
    id: "bath-toys",
    title: "Family Bath Reset",
    category: "Bathrooms",
    before: "/assets/work/bathtoys-before.webp",
    after: "/assets/work/bathtoys-after.webp",
    altBefore: "Family bath filled with toys before a Pure Bliss Clean",
    altAfter: "Fresh, reset family bath after a Pure Bliss Clean",
  },
];

export const SUBURB_PAGES = [
  {
    slug: "house-cleaning-carrum-downs",
    ratio: "aspect-[4/5]",
    suburb: "Carrum Downs",
    image: "/assets/work/bathtoys-after.webp",
    imageAlt: "Fresh, clean family bathroom in a Carrum Downs home after a Pure Bliss Clean",
    intro: "Pure Bliss Clean is proudly local to Carrum Downs. We provide reliable regular house cleaning, deep cleans and end-of-lease cleaning for homes right across the suburb — from established family homes to townhouses and newer estates.",
    local: "Carrum Downs is home, so we know the area well. Whether you're near the local shops, in one of the newer pockets towards Botanic Ridge, or anywhere in between, we bring the same detailed, consistent clean every visit — and we aim to keep the same familiar cleaners with our regular clients wherever possible.",
    popular: ["Weekly & fortnightly house cleaning", "Deep cleaning", "End of lease cleaning", "One-off cleans"],
    slider: "bath-toys",
  },
  {
    slug: "house-cleaning-frankston",
    ratio: "aspect-[4/5]",
    suburb: "Frankston",
    image: "/assets/work/kitchen-navy.webp",
    imageAlt: "Spotless navy kitchen in a Frankston home after a Pure Bliss Clean",
    intro: "Looking for a reliable cleaner in Frankston? Pure Bliss Clean provides detailed house cleaning across Frankston — from beachside apartments and units to family homes — with weekly, fortnightly and one-off options.",
    local: "Frankston homes see it all — sandy feet, salty air and busy households. We tailor each clean around your home and how you live in it, whether that's a regular weekly visit to keep on top of things or a detailed deep clean before guests arrive.",
    popular: ["Weekly & fortnightly house cleaning", "Apartment & unit cleaning", "Deep cleaning", "End of lease cleaning"],
    slider: "cooktop",
  },
  {
    slug: "house-cleaning-cranbourne",
    ratio: "aspect-[4/3]",
    suburb: "Cranbourne",
    image: "/assets/work/bathroom-timber.webp",
    imageAlt: "Fresh, detailed bathroom in a Cranbourne home after a Pure Bliss Clean",
    intro: "Pure Bliss Clean provides reliable house cleaning across Cranbourne and its growing estates — regular weekly and fortnightly cleans, deep cleaning and end-of-lease cleaning for family homes, townhouses and rentals.",
    local: "With so many growing families and new estates across Cranbourne, keeping up with the housework can be a job in itself. Our regular cleaning keeps your home fresh week after week — and we aim to send the same familiar cleaners each visit, so we learn exactly how you like things done.",
    popular: ["Weekly & fortnightly house cleaning", "Deep cleaning", "End of lease cleaning", "Property management cleaning"],
    slider: "vanity",
  },
  {
    slug: "house-cleaning-langwarrin",
    ratio: "aspect-[4/3]",
    suburb: "Langwarrin",
    image: "/assets/work/vanity-fluted.webp",
    imageAlt: "Polished double basins in a Langwarrin bathroom after a Pure Bliss Clean",
    intro: "Pure Bliss Clean is just around the corner from Langwarrin. We provide detailed regular house cleaning, deep cleans and end-of-lease cleaning for Langwarrin's family homes — reliable, consistent and friendly.",
    local: "Langwarrin's leafy streets are full of busy family homes, and we're here to help keep them feeling fresh. Choose weekly or fortnightly cleaning to stay on top of things, or book a one-off deep clean when the house needs a proper reset.",
    popular: ["Weekly & fortnightly house cleaning", "Deep cleaning", "One-off cleans", "End of lease cleaning"],
    slider: "vanity",
  },
  {
    slug: "house-cleaning-berwick",
    ratio: "aspect-[4/5]",
    suburb: "Berwick",
    image: "/assets/work/kitchen-green.webp",
    imageAlt: "Immaculate cooktop and benchtop in a Berwick kitchen after a Pure Bliss Clean",
    intro: "Pure Bliss Clean provides premium house cleaning across Berwick — regular weekly and fortnightly cleans, detailed deep cleaning and end-of-lease cleaning for the suburb's established homes and estates.",
    local: "Berwick homes deserve a clean that matches them. We focus on the details — the cooktops, the bathrooms, the skirting boards — so your home doesn't just look tidy, it genuinely feels clean. Regular clients enjoy consistent visits from the same familiar cleaners wherever possible.",
    popular: ["Weekly & fortnightly house cleaning", "Deep cleaning", "End of lease cleaning", "Pre-sale cleaning"],
    slider: "cooktop",
  },
  {
    slug: "house-cleaning-mornington",
    ratio: "aspect-[4/5]",
    suburb: "Mornington",
    image: "/assets/work/vanity-after.webp",
    imageAlt: "Polished bathroom vanity in a Mornington home after a Pure Bliss Clean",
    intro: "Pure Bliss Clean services Mornington with reliable, detailed house cleaning — regular weekly and fortnightly cleans, deep cleaning and end-of-lease cleaning for coastal homes, townhouses and units.",
    local: "Coastal living is wonderful, but it can be hard on a home. Whether you need a regular cleaner to keep your Mornington home feeling fresh, a deep clean to reset things, or a detailed end-of-lease clean before handover, we'd love to help.",
    popular: ["Weekly & fortnightly house cleaning", "Deep cleaning", "End of lease cleaning", "One-off cleans"],
    slider: "bath",
  },
];

export const AFTER_PHOTOS = [
  {
    src: "/assets/work/kitchen-navy.webp",
    title: "Kitchen Detail Clean",
    category: "Kitchens",
    alt: "Spotless navy kitchen with gleaming benchtops and appliances after a Pure Bliss Clean",
  },
  {
    src: "/assets/work/kitchen-green.webp",
    title: "Cooktop & Benchtop Finish",
    category: "Kitchens",
    alt: "Immaculate cooktop and stone benchtop after a detailed Pure Bliss Clean",
  },
  {
    src: "/assets/work/vanity-fluted.webp",
    title: "Double Basin Polish",
    category: "Bathrooms",
    alt: "Fluted double basins and vanity polished after a Pure Bliss Clean",
  },
  {
    src: "/assets/work/bathroom-timber.webp",
    title: "Full Bathroom Refresh",
    category: "Bathrooms",
    alt: "Fresh, detailed bathroom with timber vanity after a Pure Bliss Clean",
  },
];

export const WHY_CHOOSE = [
  { icon: "ShieldCheck", title: "Reliable & Consistent", text: "Cleaning you can depend on, scheduled around your needs." },
  { icon: "Users", title: "Familiar Cleaners", text: "We aim to keep the same cleaners with our regular clients wherever possible." },
  { icon: "Sparkles", title: "Attention to Detail", text: "We focus on the small details that make your home genuinely feel clean." },
  { icon: "CalendarCheck", title: "Flexible Service", text: "Cleaning arrangements can be tailored around your home and schedule." },
  { icon: "MapPin", title: "Local Service", text: "Proudly servicing homes and businesses throughout Melbourne's South East." },
  { icon: "HeartHandshake", title: "Responsive Support", text: "If something has genuinely been missed, contact us promptly and we'll work with you to make it right." },
];

// Genuine Google reviews supplied by the business owner.
// Two reviews were truncated on Google ("View full review") — shown as excerpts with an ellipsis.
export const REVIEWS = [
  {
    name: "Kaylene Joy",
    text: "I was extremely happy with the work from Pure Bliss Clean. Very thorough and very friendly and trustworthy. I will be letting everyone I know about Pure Bliss Clean.",
  },
  {
    name: "Burak Ozkok",
    text: "Good quick efficient service, easy to deal with, simple and very prompt! Highly recommended.",
  },
  {
    name: "Amanda Coleman",
    text: "I was reluctant to use a cleaning company as I never have before, however I would highly recommend this company for all…",
  },
  {
    name: "Ronic Kumar",
    text: "Pure Bliss Clean is an unbelievable company. I used to deal with other cleaning companies in the past, but since I came…",
  },
];

export const FAQS = [
  {
    q: "What areas do you service?",
    a: "We service Melbourne's South East, including Carrum Downs, Cranbourne, Skye, Langwarrin, Botanic Ridge, Frankston, Berwick, Dandenong, Seaford, Patterson Lakes, Sandhurst, Lyndhurst, Carrum, Bonbeach, Bangholme, Junction Village and Mornington. If you're nearby but don't see your suburb listed, get in touch — surrounding areas are often fine too.",
  },
  {
    q: "Do you offer regular house cleaning?",
    a: "Yes — regular residential cleaning is the heart of what we do. Weekly and fortnightly cleans are the most popular, and monthly arrangements can work well for some homes too.",
  },
  {
    q: "Can I book weekly or fortnightly cleans?",
    a: "Yes, subject to availability. Send through a quote request with your preferred frequency and we'll chat about what works for your home and schedule.",
  },
  {
    q: "Will I usually have the same cleaner?",
    a: "We aim to keep the same cleaners with our regular clients wherever possible. It helps us understand your home, your preferences and exactly how you like things done.",
  },
  {
    q: "Do you offer end-of-lease cleaning?",
    a: "Yes. We provide detailed end-of-lease cleaning to help leave your property clean, presentable and ready for inspection.",
  },
  {
    q: "Do you work with property managers and real estate agencies?",
    a: "Yes. We already provide ongoing scheduled cleaning services across residential, real estate and care environments, and we're set up for reliable, long-term arrangements with agencies and property managers.",
  },
  {
    q: "Do you offer commercial cleaning?",
    a: "Yes — we clean offices, small businesses, real estate offices and care environments, with a focus on ongoing, recurring arrangements.",
  },
  {
    q: "How do I get a quote?",
    a: "The quickest way is to fill in the quote form on this website with a few details about your property and what you need cleaned. You can also call us directly. We'll then be in touch to discuss your requirements — every home is different, so we don't list set prices online.",
  },
  {
    q: "What happens if something is missed?",
    a: "If something has genuinely been missed, let us know promptly following your clean and we'll work with you to make it right.",
  },
  {
    q: "Do you provide cleaning products and equipment?",
    a: "We can talk through products and equipment when arranging your quote — and if you have preferred products you'd like us to use, just let us know.",
  },
];

export const PROPERTY_TYPES = ["House", "Apartment", "Townhouse", "Rental Property", "Office", "Commercial Property", "Other"];
export const CLEANING_TYPES = ["Regular House Cleaning", "Deep Cleaning", "End of Lease", "Property Management", "Commercial Cleaning", "Other"];
export const FREQUENCIES = ["Weekly", "Fortnightly", "Monthly", "One Off", "Not Sure"];
